import { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { ToFormatedBackendDateFromShortISODateString, ToFormatedShortISODateFromDateString } from "../../../utils/dates";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";

const CandidateForm = ({ student, setStudent, father, mother, school, training }) => {

  //
  const updateStudentField = (field, value) => {
    let updated = {};
    updated[field] = value;
    setStudent((s) => ({
      ...s,
      ...updated,
    }));
  };
  //
  const renderListItem = (label, field, type = "text", additionalProps = {}, isSurfaceGround = true) => (
    <li className={`flex align-items-start py-2 px-2 flex-wrap ${isSurfaceGround ? "surface-ground" : ""}`}>
      <div className="text-500 w-full md:w-3 font-medium pr-2">{label}</div>
      {type === "text" ? <InputText
        type={type}
        className="p-inputtext-sm w-full md:w-9"
        value={student?.[field]}
        onInput={(e) => {
          updateStudentField(field, type === "text" ? e.target.value?.toUpperCase() : e.target.value);
        }}
        {...additionalProps}
      /> : <Checkbox
        checked={student?.[field]}
        onChange={(e) => {
          updateStudentField(field, e.checked)
        }}
        {...additionalProps}
      />}
    </li>
  );
  //
  return (
    <ul className="list-none p-0 m-0">
      {student?.status !== "UNREGISTRED" && <li className="flex align-items-start py-3 px-2 border-top-1 surface-border flex-wrap">
        <div className="text-500 w-6 md:w-2 font-medium">Elève</div>
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
          <ul className="list-none p-0 m-0">
            <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
              <div className="text-500 w-full md:w-3 font-medium pr-2">Nom de famille</div>

              <Dropdown
                className="p-inputtext-sm w-full md:w-9"                
                value={student?.lastname}
                checkmark={true}
                onChange={(e) => { updateStudentField("lastname", e.value?.toUpperCase()) }}
                options={[
                  { label: "", code: "" },
                  { label: father?.lastname, code: father?.lastname },
                  { label: mother?.lastname, code: mother?.lastname },
                ]}
                optionLabel="label"
                optionValue="code"
                placeholder=""
              />
            </li>
            {renderListItem("Prénom", "firstname", "text", {}, false)}
            <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
              <div className="text-500 w-full md:w-3 font-medium pr-2">Genre</div>

              <Dropdown
                className="p-inputtext-sm w-full md:w-9"
                value={student?.gender}
                checkmark={true}
                onChange={(e) => { updateStudentField("gender", e.value?.toUpperCase()) }}
                options={[
                  { label: "", code: "" },
                  { label: "Fille", code: "G" },
                  { label: "Garçon", code: "B" },
                ]}
                optionLabel="label"
                optionValue="code"
                placeholder="Genre"
              />
            </li>
            <li className="flex align-items-start py-2 px-2 flex-wrap">
              <div className="text-500 w-full md:w-3 font-medium pr-2">Date de naissance</div>

              <InputText type="date" className="p-inputtext-sm w-full md:w-9" value={ToFormatedShortISODateFromDateString(student?.birthday)} onChange={(e) => {
                updateStudentField("birthday", ToFormatedBackendDateFromShortISODateString(e.target.value))
              }} />
            </li>
            {renderListItem("Code postale", "postal_code", "text")}
          </ul>
        </div>
      </li>}

      {student?.status !== "UNREGISTRED" && <li className="flex align-items-start py-3 px-2 border-top-1 surface-border flex-wrap">
        <div className="text-500 w-6 md:w-2 font-medium">Autorisations</div>
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
          <ul className="list-none p-0 m-0">
            <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
              <div className="text-500 w-full md:w-3 font-medium pr-2">J'autorise mon enfant à partir seul après l'école ?</div>
              <div className="text-900 w-full md:w-9">
                <div className="card flex flex-column md:flex-row gap-3">
                  <div className="flex align-items-start">
                    <RadioButton

                      checked={student?.authorized_back_alone === true}
                      onChange={(e) =>
                        updateStudentField("authorized_back_alone", true)
                      }
                    />
                    <label className="ml-2">Oui</label>
                  </div>
                  <div className="flex align-items-start">
                    <RadioButton
                      checked={student?.authorized_back_alone === false}
                      onChange={(e) =>
                        updateStudentField("authorized_back_alone", false)
                      }
                    />
                    <label className="ml-2">Non</label>
                  </div>
                </div>
              </div>
            </li>
            <li className="flex align-items-start py-2 px-2 flex-wrap">
              <div className="text-500 w-full md:w-3 font-medium pr-2">Personnes autorisées à récupérer l'enfant après les cours ?</div>
              <div className="text-900 w-full md:w-9 line-height-3">
                <InputText type="text" className="p-inputtext-sm w-full md:w-9" value={student?.authorized_back_with} onInput={(e) => {
                  updateStudentField("authorized_back_with", e.target.value)
                }} />
              </div>
            </li>
            <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
              <div className="text-500 w-full md:w-3 font-medium pr-2">J’autorise l’école à utiliser sur ses différents supports et outils de communication, les éventuelles photographies ou vidéos de mon enfant réalisées dans le cadre de l’école ?</div>
              <div className="text-900 w-full md:w-9">
                <div className="card flex flex-column md:flex-row gap-3">
                  <div className="flex align-items-start">
                    <RadioButton

                      checked={student?.authorized_take_photo === true}
                      onChange={(e) =>
                        updateStudentField("authorized_take_photo", true)
                      }
                    />
                    <label className="ml-2">Oui</label>
                  </div>
                  <div className="flex align-items-start">
                    <RadioButton

                      checked={student?.authorized_take_photo === false}
                      onChange={(e) =>
                        updateStudentField("authorized_take_photo", false)
                      }
                    />
                    <label className="ml-2">Non</label>
                  </div>
                </div>
              </div>
            </li>
          </ul>

        </div>

      </li>}
      {student?.status !== "UNREGISTRED" && <li className="flex align-items-start py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
        <div className="text-500 w-6 md:w-2 font-medium">Renseignements médicaux</div>
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1 line-height-3">
          <ul className="list-none p-0 m-0">
            <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
              <div className="text-500 w-full md:w-3 font-medium pr-2 pr-3">L'enfant a-il des problèmes de santé ?</div>
              <InputText type="text" className="p-inputtext-sm w-full md:w-9" value={student?.health_issues} onInput={(e) => {
                updateStudentField("health_issues", e.target.value)
              }} />
            </li>
            <li className="flex align-items-start py-2 px-2 flex-wrap">
              <div className="text-500 w-full md:w-3 font-medium pr-2 pr-3">L'enfant suit-il un traitement médical ?</div>
              <InputText type="text" className="p-inputtext-sm w-full md:w-9" value={student?.medical_traitement} onInput={(e) => {
                updateStudentField("medical_traitement", e.target.value)
              }} />
            </li>
            <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
              <div className="text-500 w-full md:w-3 font-medium pr-2 pr-3">L'enfant a-il des allergies ?</div>
              <InputText type="text" className="p-inputtext-sm w-full md:w-9" value={student?.allergies} onInput={(e) => {
                updateStudentField("allergies", e.target.value)
              }} />

            </li>
            <li className="flex align-items-start py-2 px-2 flex-wrap">
              <div className="text-500 w-full md:w-3 font-medium pr-2 pr-3">L'enfant porte-il des équipements médicales ?</div>
              <InputText type="text" className="p-inputtext-sm w-full md:w-9" value={student?.medical_devices} onInput={(e) => {
                updateStudentField("medical_devices", e.target.value)
              }} />
            </li>
          </ul>
        </div>
      </li>}
      {student?.status !== "UNREGISTRED" && <li className="flex align-items-start py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
        <div className="text-500 w-6 md:w-2 font-medium">Règles intérieures</div>
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1 line-height-3">
          <ul className="list-none p-0 m-0">
            <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
              <div className="text-500 w-full md:w-3 font-medium pr-2 pr-3">Règles intérieures de l'école</div>
              <Button disabled={!training?.internal_rules_url} label="Voir les règles intérieures" icon="pi pi-eye" onClick={() => {
                window.open(training?.internal_rules_url, '_blank');
              }} />
            </li>
            <li className="flex align-items-start py-2 px-2 flex-wrap surface-ground">
              <div className="text-500 w-full md:w-3 font-medium pr-2">J'ai lu et accepté les règles intérieures de l'école ?</div>
              <div className="text-900 w-full md:w-9">
                <div className="card flex flex-column md:flex-row gap-3">
                  <div className="flex align-items-start">
                    <RadioButton

                      checked={student?.accepted_internal_rules === true}
                      onChange={(e) =>
                        updateStudentField("accepted_internal_rules", true)
                      }
                    />
                    <label className="ml-2">Oui</label>
                  </div>
                  <div className="flex align-items-start">
                    <RadioButton
                      checked={student?.accepted_internal_rules === false}
                      onChange={(e) =>
                        updateStudentField("accepted_internal_rules", false)
                      }
                    />
                    <label className="ml-2">Non</label>
                  </div>
                </div>
              </div>
            </li>

          </ul>
        </div>
      </li>}
      {student?.status === "NEW" && <li className="flex align-items-start py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
        <div className="text-500 w-6 md:w-2 font-medium">Autres informations</div>
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1 line-height-3">
          <ul className="list-none p-0 m-0">
            <li className="flex align-items-start py-2 px-2 flex-wrap">
              <div className="text-500 w-full md:w-3 font-medium pr-2 pr-3">Message à passer à l'école</div>
              <InputTextarea rows={5} className="p-inputtext-sm w-full md:w-9" value={student?.registration_details} onInput={(e) => {
                updateStudentField("registration_details", e.target.value)
              }} />
            </li>
          </ul>
        </div>
      </li>}
      {student?.status === "UNREGISTRED" && <li className="flex align-items-start py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
        <div className="text-500 w-6 md:w-2 font-medium">Autres informations</div>
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1 line-height-3">
          <ul className="list-none p-0 m-0">
            <li className="flex align-items-start py-2 px-2 flex-wrap">
              <div className="text-500 w-full md:w-3 font-medium pr-2 pr-3">Motif de la désinscription</div>
              <InputTextarea rows={5} className="p-inputtext-sm w-full md:w-9" value={student?.unregistration_reason} onInput={(e) => {
                updateStudentField("unregistration_reason", e.target.value)
              }} autoFocus />
            </li>
          </ul>
        </div>
      </li>}
    </ul >
  );
};

export default CandidateForm;